import { memo, type MouseEvent } from 'react'
import { Button, Tooltip } from '@highlight/ui'
import { FaviconImage } from '@renderer/components/favicon-image'
import type { ExtractedUrl } from './utils/extract-urls'

function openUrl(url: string) {
  window.open(url, '_blank', 'noopener,noreferrer')
}

interface ReminderLinkPillProps {
  url: string
  domain: string
}

export const ReminderLinkPill = memo(function ReminderLinkPill({ url, domain }: ReminderLinkPillProps) {
  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    e.preventDefault()
    openUrl(url)
  }

  return (
    <Tooltip>
      <Tooltip.Trigger
        render={
          <Button
            variant="outline"
            size="md"
            onClick={handleClick}
            className="min-w-0 max-w-36 flex-shrink-0"
            left={
              <div className="corner-smooth aspect-square h-5 w-5 flex-shrink-0 overflow-hidden rounded-md">
                <FaviconImage domain={domain} size={20} />
              </div>
            }
          >
            <span className="truncate">{domain}</span>
          </Button>
        }
      />
      <Tooltip.Content>{url}</Tooltip.Content>
    </Tooltip>
  )
})

interface ReminderLinkAttachmentsProps {
  /** Pre-extracted URLs — the cell already runs extractUrls once per title. */
  urls: Array<ExtractedUrl>
}

export const ReminderLinkAttachments = memo(function ReminderLinkAttachments({ urls }: ReminderLinkAttachmentsProps) {
  if (urls.length === 0) return null

  return (
    <>
      {urls.map((u) => (
        <ReminderLinkPill key={u.url} url={u.url} domain={u.domain} />
      ))}
    </>
  )
})
